export type { TextFitProps } from "./TextFit";
export { TextFit } from "./TextFit";
